import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { AuthenticationService } from '../login/authentication/authentication.service';


@Injectable()
export class ErrorInterceptor implements HttpInterceptor {

    constructor(private authenticationService: AuthenticationService) { }

    public intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        return next.handle(request).pipe(catchError(err => {

            let parsedError: any;

            if (err && err.error) {
                if (typeof err.error == 'string') {
                    parsedError = Object.assign({}, err, { error: JSON.parse(err.error) });
                    console.log(parsedError.error.message);
                    console.log(parsedError.error.message.indexOf('error_usuario_sem_permissao'));
                } else {
                    parsedError = err;
                }
            }

            if (this.authenticationService.currentUser) {

                // auto logout if 401 or 403 response returned from api
                if ([403].includes(err.error.message)) {

                    this.authenticationService.logout();

                } else if ([401].includes(err.status) &&
                    (!parsedError.error || !parsedError.error.message || parsedError.error.message.indexOf('error_usuario_sem_permissao') == -1)) {

                    this.authenticationService.logout();

                }
            }

            console.error(err);
            return throwError(err);
        }))
    }
}
